import axios from "axios";

export default {
  initAttributions(
    { commit, state, dispatch },
    { firstDate, lastDate, engagementId, engagementTypeId, isSummary, timezone }
  ) {
    commit("setInitialState", {
      firstDate,
      lastDate,
      engagementId,
      engagementTypeId,
      isSummary,
    });
    commit("setIsLoading", { isLoading: true });
    commit("setTimezone", { timezone: timezone });
    let d = {
      engagement_id: engagementId,
      page: 1,
      min_value: 0,
      max_value: 1000000,
      attribution_reason_id: 0,
    };
    if (isSummary) {
      d.engagement_type_id = engagementTypeId;
    } else {
      d.engagement_id = engagementId;
    }
    if (firstDate !== null) {
      d.first_date = firstDate;
    }
    if (lastDate !== null) {
      d.last_date = lastDate;
    }
    axios
      .post("/json/engagements/loadAttributions", d)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setEngagement", { engagement: res.engagement });
        commit("setAttributions", { attributions: res.attributions });
        commit("setIsLoading", { isLoading: false });
      });
  },
  loadAttributions(
    { commit, state, dispatch },
    { page, minValue, maxValue, reasonId }
  ) {
    commit("setIsLoading", { isLoading: true });
    let d = {
      engagement_id: state.engagementId,
      page: page,
      min_value: minValue,
      max_value: maxValue,
      attribution_reason_id: reasonId,
    };
    if (state.isSummary) {
      d.engagement_type_id = state.engagementTypeId;
    } else {
      d.engagement_id = state.engagementId;
    }
    if (state.firstDate !== null) {
      d.first_date = state.firstDate;
    }
    if (state.lastDate !== null) {
      d.last_date = state.lastDate;
    }
    axios
      .post("/json/engagements/loadAttributions", d)
      .then(
        (json) =>
          new Promise((resolve, reject) => {
            resolve(json.data);
          })
      )
      .catch((err) => {
        console.log(err);
        return {};
      })
      .then((res) => {
        commit("setAttributions", { attributions: res.attributions });
        commit("setIsLoading", { isLoading: false });
      });
  },
};
